import * as React from 'react';
import { Backdrop } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

interface IProps {
  isLoad?: boolean;
  style?: React.CSSProperties;
}

export default function Loading({ isLoad, style }: IProps) {
  return (
    <Backdrop
      open={!!isLoad}
      sx={{
        color: '#94a3b8',
        background: 'white',
        zIndex: 999,
        position: 'absolute',
        ...style,
      }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
